import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCurrentPlan,
  fetchSubscription,
  fetchPaymentHistory,
  initiatePayment,
  cancelSubscription,
} from "../thunks/paymentThunks";
import { DEFAULT_PLAN } from "../../config/plans.config";

const initialState = {
  currentPlan: DEFAULT_PLAN,
  quotas: null,
  subscription: null,
  history: [],

  checkoutUrl: null,
  checkoutPlan: null,

  loadingPlan: false,
  loadingSubscription: false,
  loadingHistory: false,
  loadingCheckout: false,
  loadingCancel: false,

  error: null,
  checkoutError: null,
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    clearCheckout: (state) => {
      state.checkoutUrl = null;
      state.checkoutPlan = null;
      state.checkoutError = null;
    },
    clearPaymentError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentPlan.pending, (state) => {
        state.loadingPlan = true;
        state.error = null;
      })
      .addCase(fetchCurrentPlan.fulfilled, (state, action) => {
        state.loadingPlan = false;
        state.currentPlan = action.payload?.plan || DEFAULT_PLAN;
        state.quotas = action.payload?.quotas || null;
      })
      .addCase(fetchCurrentPlan.rejected, (state, action) => {
        state.loadingPlan = false;
        state.error = action.payload;
      })

      .addCase(fetchSubscription.pending, (state) => {
        state.loadingSubscription = true;
      })
      .addCase(fetchSubscription.fulfilled, (state, action) => {
        state.loadingSubscription = false;
        state.subscription = action.payload || null;
      })
      .addCase(fetchSubscription.rejected, (state, action) => {
        state.loadingSubscription = false;
        state.error = action.payload;
      })

      .addCase(fetchPaymentHistory.pending, (state) => {
        state.loadingHistory = true;
      })
      .addCase(fetchPaymentHistory.fulfilled, (state, action) => {
        state.loadingHistory = false;
        state.history = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchPaymentHistory.rejected, (state, action) => {
        state.loadingHistory = false;
        state.error = action.payload;
      })

      .addCase(initiatePayment.pending, (state, action) => {
        state.loadingCheckout = true;
        state.checkoutError = null;
        state.checkoutPlan = action.meta.arg?.plan || null;
      })
      .addCase(initiatePayment.fulfilled, (state, action) => {
        state.loadingCheckout = false;
        state.checkoutUrl = action.payload?.paymentUrl || null;
      })
      .addCase(initiatePayment.rejected, (state, action) => {
        state.loadingCheckout = false;
        state.checkoutError = action.payload;
      })

      .addCase(cancelSubscription.pending, (state) => {
        state.loadingCancel = true;
      })
      .addCase(cancelSubscription.fulfilled, (state) => {
        state.loadingCancel = false;
        if (state.subscription) {
          state.subscription.status = "cancelled";
          state.subscription.autoRenew = false;
        }
      })
      .addCase(cancelSubscription.rejected, (state, action) => {
        state.loadingCancel = false;
        state.error = action.payload;
      });
  },
});

export const { clearCheckout, clearPaymentError } = paymentSlice.actions;
export default paymentSlice.reducer;
